var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "forgot-password-div" } }, [
    _c("h1", { staticClass: "page-title mt-5" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("verificationCodeTitle")) + "\n  ")
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "page-subtitle mt-3" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("verificationCodeSubtitle1"))),
      _c("strong", [_vm._v(_vm._s(_vm.phoneNumber))]),
      _vm._v(_vm._s(_vm.$t("verificationCodeSubtitle2")) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "mt-4",
        on: {
          submit: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.handleSmsSubmit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "b-alert",
          { attrs: { show: _vm.ui.showError, variant: "danger" } },
          [_vm._v("\n      " + _vm._s(_vm.ui.showErrorMessage) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          {
            attrs: { label: _vm.$t("smsCredential"), "label-for": "code-input" }
          },
          [
            _c("b-form-input", {
              attrs: { id: "code-input", required: "" },
              on: { keydown: _vm.hideMessages },
              model: {
                value: _vm.form.code.value,
                callback: function($$v) {
                  _vm.$set(_vm.form.code, "value", $$v)
                },
                expression: "form.code.value"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-block",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v(_vm._s(_vm.$t("smsButtonText")))]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-4 text-right" },
      [
        _c(
          "b-link",
          { staticClass: "link-main-color", on: { click: _vm.showLoginView } },
          [_vm._v(_vm._s(_vm.$t("smsBackToLoginText")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f1d433a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f1d433a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/SmsCodeComponent.vue
// module id = CnNg
// module chunks = 0